
var SvgPath__prototype = SvgPath.prototype;